import { Context } from '@nuxt/types'
import merge from 'lodash/merge'
import { Vue } from '~/node_modules/nuxt-property-decorator'

enum Module {
  CURRENT_VIEWS = 'currentViews',
}

export interface LiveData {
  subscribeCurrentViews: (variantId: string) => null
  data: {
    [module: string]: {
      [variantId: string]: number
    }
  }
}

export default (context: Context) => {
  let socket: WebSocket | null = null
  const innerData = new Vue({
    data: {
      $liveData: {
        data: {},
      },
    },
  })

  function connect() {
    const liveDataSocketUrl = context.app.$env!.liveDataSocketUrl

    socket = new WebSocket(liveDataSocketUrl)
    socket.onmessage = (message) => {
      processMessage(message)
    }
  }

  function processMessage(message: MessageEvent) {
    const parsedData = JSON.parse(message.data)

    const processedData = {
      [parsedData.module]: parsedData.data,
    }

    const result = merge({}, innerData.$data.$liveData.data, processedData)
    Vue.set(innerData.$data.$liveData, 'data', result)
  }

  function subscribeCurrentViews(variantId: string) {
    send(Module.CURRENT_VIEWS, variantId)
  }

  function send(module: Module, variantId: string) {
    const shopId = context.app.$shopConfig!.shopId

    const sendMessage = () =>
      socket!.send(
        JSON.stringify({
          MallWebSocket__REQUEST: {
            data: { items: [variantId] },
            metaData: [window.innerWidth, window.innerHeight], // no idea why we need this
            module,
            shopId,
          },
        })
      )

    if (socket) {
      return sendMessage()
    }

    connect()
    socket!.onopen = () => {
      sendMessage()
    }
  }

  Vue.mixin({
    computed: {
      $liveData: {
        get() {
          return {
            data: innerData.$data.$liveData.data,
            subscribeCurrentViews,
          }
        },
        set(newData) {
          innerData.$data.$liveData.data = newData
        },
      },
    },
  })
}
